
// @ts-nocheck


export const localeCodes =  [
  "en-eu",
  "pl-pl"
]

export const localeLoaders = {
  "en-eu": [
    {
      key: "locale_en_45GB_46json_69befa78",
      load: () => import("#nuxt-i18n/69befa78" /* webpackChunkName: "locale_en_45GB_46json_69befa78" */),
      cache: true
    }
  ],
  "pl-pl": [
    {
      key: "locale_pl_45PL_46json_d338f718",
      load: () => import("#nuxt-i18n/d338f718" /* webpackChunkName: "locale_pl_45PL_46json_d338f718" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ee4e6a16" /* webpackChunkName: "config_i18n_46config_46ts_ee4e6a16" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en-eu",
      language: "en-GB",
      domain: "en-eu.localhost:3000",
      files: [
        {
          path: "/app/i18n/locales/en-GB.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pl-pl",
      language: "pl-PL",
      domain: "pl-pl.localhost:3000",
      files: [
        {
          path: "/app/i18n/locales/pl-PL.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en-eu",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en-eu",
    language: "en-GB",
    domain: "en-eu.localhost:3000",
    files: [
      {
        path: "/app/i18n/locales/en-GB.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl-pl",
    language: "pl-PL",
    domain: "pl-pl.localhost:3000",
    files: [
      {
        path: "/app/i18n/locales/pl-PL.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/